const UserIcon = ({ size = 16, color = '#212529' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10671 7.74732C6.08671 7.74732 6.07337 7.74732 6.05337 7.74732C6.02004 7.74065 5.97337 7.74065 5.93337 7.74732C4.00004 7.68732 2.54004 6.16732 2.54004 4.29398C2.54004 2.38732 4.09337 0.833984 6.00004 0.833984C7.90671 0.833984 9.46004 2.38732 9.46004 4.29398C9.45337 6.16732 7.98671 7.68732 6.12671 7.74732C6.12004 7.74732 6.11337 7.74732 6.10671 7.74732ZM6.00004 1.83398C4.64671 1.83398 3.54004 2.94065 3.54004 4.29398C3.54004 5.62732 4.58004 6.70065 5.90671 6.74732C5.94671 6.74065 6.03337 6.74065 6.12004 6.74732C7.42671 6.68732 8.45337 5.61398 8.46004 4.29398C8.46004 2.94065 7.35337 1.83398 6.00004 1.83398Z"
      fill={color}
    />
    <path
      d="M6.11307 15.0327C4.80641 15.0327 3.49307 14.6993 2.49974 14.0327C1.57307 13.4193 1.06641 12.5793 1.06641 11.666C1.06641 10.7527 1.57307 9.90602 2.49974 9.28602C4.49974 7.95935 7.73974 7.95935 9.72641 9.28602C10.6464 9.89935 11.1597 10.7393 11.1597 11.6527C11.1597 12.566 10.6531 13.4127 9.72641 14.0327C8.72641 14.6993 7.41974 15.0327 6.11307 15.0327ZM3.05307 10.126C2.41307 10.5527 2.06641 11.0993 2.06641 11.6727C2.06641 12.2393 2.41974 12.786 3.05307 13.206C4.71307 14.3193 7.51307 14.3193 9.17307 13.206C9.81307 12.7793 10.1597 12.2327 10.1597 11.6593C10.1597 11.0927 9.80641 10.546 9.17307 10.126C7.51307 9.01935 4.71307 9.01935 3.05307 10.126Z"
      fill={color}
    />
  </svg>
);

export default UserIcon;
